import React from 'react';
import './button.css';

const Button = (props) => {
  return ( 
    <button className={props.className} onClick={props.onclick}>
      {props.children}
    </button>
   );
}
 
export default Button;
